import React, { SyntheticEvent } from 'react';
import styled from 'styled-components';

import 'video-react/dist/video-react.css';
import { Tag, Tags } from '../../../interfaces';
import { humanizeEnum } from '../../../utils';
import { Button, ButtonProps, ButtonsBox, CopyToClipboard, H3, SpaceBetween, Tooltip } from '../../atoms';

interface Props {
  question: Tag;
  tags: any;
  setTags?: any;
  onUserTagChange?: any;
  disabled?: boolean;
  onTagClick: (
    path: Tag,
    value?: any,
    tags?: Tags,
    setTags?: (tags: Tags) => void,
    onUserTagChange?: (tags: Tags) => void,
  ) => (evt?: SyntheticEvent) => void;
  withCopy?: boolean;
}

const getVariant = (question: Tag, value: any, tags: any): ButtonProps['variant'] => {
  let variant = 'gray';
  const path = `td:${question.id}`;

  if (question.value_type === 'bool') {
    if (tags[path] === true) {
      variant = 'accept';
    } else if (tags[path] === false) {
      variant = 'danger';
    }
  } else {
    variant = tags[path] === `ev:${value}` ? 'primary' : 'gray';
  }

  return variant as ButtonProps['variant'];
};

const CopyToClipboardWrapper = styled('div')`
  margin-left: 8px;
`;

export function Question(props: Props) {
  const { question, tags, onTagClick, withCopy, setTags, onUserTagChange, disabled } = props;

  if (question.value_type === 'int') {
    // FIXME Zhush it up a little
    return (
      <SpaceBetween>
        <input
          type="range"
          min={question.min_value}
          max={question.max_value}
          key={question.id}
          value={tags[question.id]}
          onChange={onTagClick(question)}
        />
        <H3>{tags[question.id]}</H3>
      </SpaceBetween>
    );
  }

  if (question.value_type === 'bool') {
    // FIXME Zhush it up a little
    const variant = getVariant(question, question.id, tags);
    return (
      <ButtonsBox>
        <Button
          key={question.id + variant}
          variant={variant}
          data-test={variant === 'gray' ? 'button-tag-empty' : 'button-tag-filled'}
          onClick={onTagClick(question, question.id, setTags, onUserTagChange)}
          title={question.description}
          disabled={disabled}
        >
          {humanizeEnum(question.name)}
        </Button>
      </ButtonsBox>
    );
  }

  return (
    <ButtonsBox>
      {question.enum_variants?.map((value) => {
        const variant = getVariant(question, value.id, tags);
        if (value.state !== 'active') {
          return null;
        }

        return (
          <Button
            key={value.id + variant}
            variant={variant}
            data-test={variant === 'gray' ? 'button-tag-empty' : 'button-tag-filled'}
            onClick={onTagClick(question, value.id, tags, setTags, onUserTagChange)}
            title={value.description}
            disabled={disabled}
          >
            {humanizeEnum(value.variant_name)}
            {withCopy && (
              <CopyToClipboardWrapper>
                <Tooltip tooltip={`Enum ID: ${value.id}`}>
                  <CopyToClipboard textToCopy={`${value.id}`} />
                </Tooltip>
              </CopyToClipboardWrapper>
            )}
          </Button>
        );
      })}
    </ButtonsBox>
  );
}
